module.exports = __webpack_public_path__ + "img/AL802.1995357a.jpg";